import { SignupRedirect } from './SignupRedirect';

/** Legacy `/signup` URLs forward to the combined auth screen at `/login`. */
export function SignupPage() {
  return <SignupRedirect />;
}
